// extracted by mini-css-extract-plugin
export default {"formStyles":"Subscriptions_formStyles__sCvln"};